import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-nav-open"
export default class extends Controller {
  static targets = ["target", "arrowbutton"]

  toggle(e) {
    if(window.innerWidth < 1024){
      e.preventDefault();
      e.stopPropagation();
      this.targetTarget.classList.toggle('open');
      this.arrowbuttonTarget.classList.toggle('rotate');
    } else {
      return;
    }
  }
}
